/** Drive-unit occupancy rows owned by transient UI (dialogs), not parsed hardware cards. */
export function isSyntheticDriveUnitPortElectronic(electronic: string): boolean {
  return electronic.startsWith('__snippet_drop__') || electronic.startsWith('__pending_action_drop__');
}
